module.exports = __webpack_public_path__ + "img/kp1.bd7bd74f.png";